import type { OptionsFilter } from '@mantine/core';

// Form field names for the employment pair — shared by EmploymentSection (inputs)
// and useJoinAndAllocationOtherDetails (validation shape, hydration, save).
export const EMPLOYER_NAME_FIELD = 'employerName';
export const EMPLOYEE_ID_FIELD = 'employeeId';

// Mantine filters Autocomplete options by the input text, so a prefilled employer
// name would hide every other option until the field is cleared. Show the full list
// when the input exactly matches an option (prefilled / just selected), and filter
// as-you-type otherwise — mirroring how a searchable Select behaves.
export const employerOptionsFilter: OptionsFilter = ({ options, search }) => {
	const query = search.trim().toLowerCase();
	const matchesOptionExactly = options.some(
		(option) => 'label' in option && option.label.toLowerCase() === query
	);
	if (!query || matchesOptionExactly) {
		return options;
	}
	return options.filter(
		(option) => !('label' in option) || option.label.toLowerCase().includes(query)
	);
};
